import {connect} from 'react-redux';
import DetailLink from '../components/DetailLink';
import {showShopDetails} from '../actions';

const mapStateToProps = state => {
  return {
    asLink: !!state.config.detailsInTab
  }
};

const mapDispatchToProps = (dispatch) => ({
  onClick: parcelShopNumber => dispatch(showShopDetails(parcelShopNumber))
});

export default connect(mapStateToProps, mapDispatchToProps)(DetailLink)
